import React from "react";
import { Container, Button, Row, Col, Card} from "react-bootstrap";
const benefitList = [
  "Enhanced donor engagement and retention",
  "Reduced wastage with real-time inventory alerts",
  "Improved transfusion safety and traceability",
  "Regulatory compliance and secure data management",
  "Cloud-based access from anywhere, anytime"
];

const features = [
  {
    title: "Donor Management",
    description:
      "Maintain comprehensive donor records, eligibility, and donation history with automated reminders for repeat donations.",
  },
  {
    title: "Inventory Tracking",
    description:
      "Real-time tracking of blood units, components, and expiry dates with alerts for low stock and expiring inventory.",
  },
  {
    title: "Cross-Matching & Compatibility",
    description:
      "Automated blood group compatibility checks and cross-matching for safe transfusions.",
  },
  {
    title: "Regulatory Compliance",
    description:
      "Built-in compliance tools for NACO, FDA, and other regulations, including audit trails and documentation.",
  },
  {
    title: "Patient & Hospital Portal",
    description:
      "Secure online portal for hospitals and patients to request blood, check availability, and track requests.",
  },
  {
    title: "Analytics & Reporting",
    description:
      "Visual dashboards and reports for donor trends, inventory status, and compliance monitoring.",
  },
];


const internalStyles = `
  :root {
    --medisevas-blue: #0084d9;
    --medisevas-green: #0d622b;
    --medisevas-black: #000;
    --medisevas-light-bg: #f7f7f7;
  }
 .section-title h2 {
  color: var(--medisevas-green);
  font-weight: 700;
  position: relative; /* needed for ::after absolute positioning */
  padding-bottom: 15px;
  text-transform: uppercase;
}

.section-title h2::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  display: block;
  width: 60px;
  height: 4px;
  background: var(--medisevas-blue);
  border-radius: 2px;
}
.features-section  h2 {
  color: var(--medisevas-green);
  font-weight: 500;
  position: relative; /* needed for ::after absolute positioning */
  padding-bottom: 15px;
  text-transform: uppercase;
}
.benefits-section h2 {
  color: var(--medisevas-green);
  font-weight: 500;
  position: relative; /* needed for ::after absolute positioning */
  padding-bottom: 15px;
  text-transform: uppercase;
}

  /* --- Service Card Styles (Alternating Feature Blocks) --- */
  .service-card {
    background: #ffffff;
    /* Reverting to closer to original service-card styles for consistency, but improved spacing/layout maintained */
    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1); 
    border-radius: 8px; 
    padding: 40px; 
    transition: box-shadow 0.3s ease;
    display: flex;
    flex-direction: column;
    gap: 2rem;
    align-items: center; 
  }
  .service-card:hover {
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.15); /* Hover shadow from original */
  }
  
  @media (min-width: 992px) {
    .service-card {
      flex-direction: row;
      align-items: center; 
    }
    .service-img-wrapper {
      max-width: 45%; 
      width: 100%; /* Ensure max-width is respected */
      flex-shrink: 0;
    }
    .service-text {
      max-width: 55%;
      padding: 0 20px;
    }
  }
  
  .service-text h4 {
    color: var(--medisevas-green); /* Using green for h4 in services */
    font-weight: 700;
    margin-bottom: 1rem;
    font-size: 1.75rem;
  }
  
  .service-text p {
    color: #444; /* Using #444 from original service-text p */
    line-height: 1.6; /* Using 1.6 from original service-text p */
    font-size: 1rem;
  }

  /* --- CTA Section Styles (medisevas-dark-bg) --- */
  .medisevas-dark-bg {
    /* Using the linear-gradient from your provided styles */
     background: #a3cfbb;
    color: var(--medisevas-black);
    padding: 80px 0; /* Ensuring consistent section padding */
  }
  .medisevas-dark-bg h3 {
    /* Styles for the main CTA title */
    color: var(--medisevas-green);
    font-weight: 500;
    margin-bottom: 1.5rem;
    font-size: 2rem; /* Enhanced size for impact */
  }
  .medisevas-dark-bg p {
    font-size: 1rem;
    margin-bottom: 2.5rem;
    color: #444;
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
    white-space: nowrap;
    
  }
  
  /* Button Styles (Re-consolidated from provided styles) */
  .medisevas-btn {
    background-color: var(--medisevas-blue);
    border: none;
    color: #fff;
    padding: 10px 20px;
    margin: 0 4px; /* Adjusting margin for cleaner button grouping */
    border-radius: 6px;
    font-weight: 600;
    transition: background 0.2s;
    cursor: pointer;
    text-decoration: none;
    display: inline-block;
  }
  .medisevas-btn-success {
    background-color: var(--medisevas-green);
  }
  .medisevas-btn-outline {
    background: none;
    color: var(--medisevas-green);
    border: 2px solid var(--medisevas-green);
  }
  .medisevas-btn:hover,
  .medisevas-btn-success:hover {
    background-color: var(--medisevas-green);
    color: #fff;
    text-decoration: none;
  }
  .medisevas-btn-outline:hover {
    background-color: var(--medisevas-green);
    color: #fff;
  }
  .hero-buttons {
    margin-top: 30px;
  }
  .mb-3 {
    margin-bottom: 1rem !important; /* Bootstrap mb-3 value */
  }
  .py-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }

 .benefits-section {
    background: #f7f9fa;
    padding: 30px 0;
    text-align: center;
  }

  .benefits-list-wrapper {
    display: flex;
    justify-content: center;
  }
  .benefits-list-box {
    background: #fff;
    max-width: 700px;
    width: 100%;
    border-radius: 6px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.03);
    overflow: hidden;
    border: 1px solid #eee;
  }
  .benefits-list {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  .benefits-list li {
    padding: 10px 10px;
    border-bottom: 1px solid #ececec;
    font-size: 1.05rem;
    color: #222e39;
    text-align: left;
  }
  .benefits-list li:last-child {
    border-bottom: none;
  }
`;
const BloodBankLabManagement = ({ history }) => {
  const navigateAndScroll = (path) => (e) => {
    e.preventDefault();
    if (history && typeof history.push === "function") {
      history.push(path);
    } else {
      // Fallback for non-router environments or modern react-router-dom v6 (replace with useNavigate hook)
      // If history is not available, it still performs the scroll and navigates via native URL change
      window.location.href = path;
    }
    window.scrollTo(0, 0);
  };

  return (
    <>
    <style>{internalStyles}</style>
      <section className="hero-section py-5 bg-light text-center mt-5">
        <Container>
          <div className="section-title">
            <h2>Blood Bank Management Software</h2>
            <p className="lead mb-4">
             Digitize and streamline your blood bank operations with our secure, cloud-based management solution for donor, inventory, and compliance management.
            </p>
            <Button
              href="/contact-us"
              onClick={navigateAndScroll("/contact-us")}
              className="me-0 me-sm-2 mx-1"
              variant="success"
            >
              Request a Free Demo
            </Button>
          </div>
        </Container>
      </section>
       <section className="features-section py-5">
      <Container>
        <h2 className="mb-4 text-center">Key Features</h2>
        <Row className="g-4">
          {features.map((feature, idx) => (
            <Col key={idx} md={4}>
              <Card className="h-100 shadow-sm">
                <Card.Body>
                  <Card.Title>{feature.title}</Card.Title>
                  <Card.Text>{feature.description}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>

     <section className="benefits-section">
      <Container>
        <h2 className="benefits-heading">Benefits</h2>
        <div className="benefits-list-wrapper">
          <div className="benefits-list-box">
            <ul className="benefits-list">
              {benefitList.map((benefit, idx) => (
                <li key={idx}>{benefit}</li>
              ))}
            </ul>
          </div>
        </div>
      </Container>
    </section>
         {/* 3. CTA Section - Using the requested markup and consolidated styles */}
      <section className="medisevas-section medisevas-dark-bg py-5">
        <div className="container text-center">
          <h3>
            Empowering Your Blood Bank for the Future
            {/* Assisting You in Expanding Without Boundaries,
            <br />
            Your Development is Our Main Concern */}
          </h3>
          <p>
          Schedule a demonstration, and our representative will provide you with an in-depth overview of our product and address any questions you may have.
          </p>
          <div className="hero-buttons mb-3">
            {/* Contact with Us */}
            <a
              className="medisevas-btn medisevas-btn-outline mx-1"
              href="/contact-us"
              onClick={navigateAndScroll("/contact-us")}
            >
              Contact with Us
            </a>

            {/* Book a Demo */}
            <a
              className="medisevas-btn medisevas-btn-success mx-1"
              href="/contact-us"
              onClick={navigateAndScroll("/contact-us")}
            >
              Book a Demo
            </a>

            {/* Partner with Us */}
            <a
              className="medisevas-btn medisevas-btn-outline mx-1"
              href="/partner-with-us"
              onClick={navigateAndScroll("/partner-with-us")}
            >
              Partner with Us
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default BloodBankLabManagement;
